import { FC } from 'react';
import style from './PageContent.module.scss';

export const PageContent: FC = ({ children }) => {
  return (
    <div className={style.content}>
      {children}
    </div>
  );
};
